import { Model } from '@models/core/base.model';

export class EmployeeAdditionalIncome extends Model {
    protected static _resource = 'payroll/employees/:employee/additionalIncomes';

    protected static _version = 'v2';

    protected static _serializeAttributes = ['active', 'amount', 'companyAdditionalIncomeId'];

    set active(value: boolean) {
        this._attributes['active'] = value;
    }

    set amount(value: number) {
        this._attributes['amount'] = value;
    }

    get active(): boolean {
        return this._attributes['active'];
    }

    get amount(): number {
        return this._attributes['amount'];
    }

    get recurrable(): boolean {
        return this._attributes['recurrable'];
    }

    get frequency(): string {
        return this._attributes['frequency'];
    }

    get prEmployeeId(): number {
        return this._attributes['prEmployeeId'];
    }

    set companyAdditionalIncomeId(value: number) {
        this._attributes['companyAdditionalIncomeId'] = value;
    }

    get companyAdditionalIncomeId(): number {
        return this._attributes['companyAdditionalIncomeId'];
    }
}
